import React from "react";
import PageShell from "../components/PageShell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "../styles/app/LogoutPage.scss";

const LogoutPage: React.FC = () => {
  return (
    <PageShell>
      <div className="logout-container">
        <div className="logout-content">
          <div className="logout-icon">
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="logout-checkmark"
            />
          </div>
          <h2 className="logout-title">Successfully Logged Out</h2>
          <p className="logout-message">
            <br />
            You can now safely close this browser window.
          </p>
        </div>
      </div>
    </PageShell>
  );
};

export default LogoutPage;
